<script>
    import Workshop from "./WorkshopComponent.svelte";
    import { onMount, tick } from "svelte";

    export let shouldScroll = true;

    let scrollTarget;

    onMount(async () => {
        if (shouldScroll) {
            await tick();
            scrollTarget.scrollIntoView();
        }
    });

    let workshops = [
        {
            title: "ACM Ice Cream Social + New Officer Applications!",
            date: "May 13th @ 6:00 PM",
            description: "Join us for our final event of the semester—featuring Maryland Dairy ice cream (yes, the good stuff 😋) and applications for next year's open officer positions:💰 Treasurer🌐 Web Developer📣 Outreach Officer. We'll also be recognizing the hard work of our current team and giving a special shoutout to our graduating officers 🎓 Whether you're looking to get more involved or just want to hang out before summer—come by!",
            imageUrl: "/assets/meetings/icecream.jpg",
            githubLink: "",
            youtubeLink: "",
            location: "IRB ROOF @ UMD",
            zoomLink: "",
            rsvpLink: "https://docs.google.com/forms/d/e/1FAIpQLSeotFIxk93phpG-5EBPJc4r2NBTuXJjwe8jJcFeEaUX79e8gQ/viewform?usp=dialog",
            timestamp: new Date("2025-05-13T18:00:00-04:00").getTime(),
            category: "Social",
            difficulty: "Beginner",
            semester: "Spring 2024",
        },
        {
            title: "The State & Future of Quantum",
            date: "April 29th @ 6:00 PM",
            description:
                "Curious about quantum computing? Join Dr. Mark Jackson, Senior Quantum Evangelist at Quantinuum, as he breaks down the core ideas, impact, and future of this game-changing technology. Open to all—whether you're into physics, software, entrepreneurship, or just want to learn something new.",
            imageUrl: "/assets/meetings/Mark Jackson.jpg",
            githubLink: "",
            youtubeLink: "",
            location: "Iribe 0318 @ UMD",
            zoomLink: "",
            rsvpLink: "",
            timestamp: new Date("2025-04-29T18:00:00").getTime(),
            category: "Tech Talk",
            difficulty: "Beginner",
            semester: "Spring 2025",
        },
        {
            title: "Build Your Own AI Voice Assistant",
            date: "April 8th @ 6:00 PM",
            description:
                "In this hands-on workshop, you'll create your very own personalized AI voice assistant using Python, speech recognition, and tools like LM Studio. Learn how to make it listen, respond, automate tasks—and even customize its tone and personality! No experience needed, just bring your laptop.",
            imageUrl: "/assets/meetings/arvin.jpg",
            githubLink: "https://docs.google.com/presentation/d/18U66ObsGOP1sXC3-V9Q7AuGWyVB2K_o3CYhiAhwGyIA/edit?usp=sharing",
            youtubeLink: "",
            location: "CSI 2117 @ UMD",
            zoomLink: "",
            rsvpLink: "",
            timestamp: new Date("2025-04-08T18:00:00").getTime(),
            category: "Workshop",
            difficulty: "Medium",
            semester: "Spring 2025",
        },
        {
            title: "Create your Website Workshop",
            date: "March 10th @ 6:00 PM",
            description:
                "Want to build a website but have no coding experience? Join our beginner-friendly workshop to create and customize your own site with easy-to-use tools. Just bring your laptop!",
            imageUrl: "/assets/meetings/meet.jpg",
            githubLink: "",
            youtubeLink: "",
            location: "IRB 5105 @ Iribe",
            zoomLink: "https://umd.zoom.us/j/94923471605",
            rsvpLink: "",
            timestamp: new Date("2025-03-10T18:00:00").getTime(),
            category: "Workshop",
            difficulty: "Beginner",
            semester: "Spring 2025",
        },
        {
            title: "Sandia National Labs Tech Talk!",
            date: "Feb. 24th @ 6:00 PM",
            description:
                "Join Sandia National Labs for a Tech Talk on cutting-edge research in national security, energy, and scientific computing. Hear from experts shaping the future of innovation!",
            imageUrl: "/assets/meetings/SNL.png",
            githubLink: "",
            youtubeLink: "",
            location: "IRB 0324 Antonov Auditorium @ Iribe",
            zoomLink: "https://umd.zoom.us/j/94923471605",
            rsvpLink: "",
            timestamp: new Date("2025-02-24T18:00:00").getTime(),
            category: "Tech Talk",
            difficulty: "Beginner",
            semester: "Spring 2025",
        },
        {
            title: "Research Q & A with Alan Sussma (attendance ~ 40+)",
            date: "November 12th @ 6:00 PM - 7:00 PM",
            description:
                "Join us on Tuesday as Dr. Alan Sussman dives into his research in High performance Computing and Systems. Students will have a chance to engage in an in depth Q & A session on CS dept research and how they can get involved!",
            imageUrl: "/assets/meetings/sussman.jpg",
            githubLink: "",
            youtubeLink: "",
            location: "CSI 1121",
            zoomLink: "https://umd.zoom.us/j/94923471605",
            rsvpLink: "",
            timestamp: new Date("2024-11-12T18:00:00").getTime(),
            category: "Workshop",
            difficulty: "Medium",
            semester: "Fall 2024",
        },
        {
            title: "Shell Slayer – ACM Halloween Event (attendance ~ 50+)",
            date: "October 29 @ 6:00 PM - 8:00 PM",
            description:
                "This Halloween, Professor Christopher Kauffman will teach you how to navigate the terminal and use powerful commands to hunt down and slay a rogue daemon wreaking havoc on the ACM's files. You'll learn terminal skills like navigating filesystems, tracking processes, and using kill commands. No coding experience needed—just your wits and love for adventure! Come for the code, stay for the frights, and leave with the power to tame the terminal!",
            imageUrl: "/assets/meetings/kaufman.jpg",
            githubLink: "https://github.com/The-ACM-UMD/shell-slayer",
            youtubeLink: "",
            location: "IRB 0324",
            zoomLink: "https://umd.zoom.us/j/94923471605#success",
            rsvpLink:
                "https://docs.google.com/forms/d/e/1FAIpQLSdMHH_6eRwEm_MhNrLaBL1H4t1yXBOYfTAATtAcMZEP1NcdZw/viewform",
            timestamp: new Date("2024-10-29T18:00:00").getTime(),
            category: "Workshop",
            difficulty: "Beginner",
            semester: "Fall 2024",
        },
        {
            title: "Computer Vision and Robotics Lab Tour! (attendance ~ 30+)",
            date: "October 17 @ 6:00 PM - 7:00 PM",
            description:
                "Join ACM for a guided tour of UMD's Robotics and Computer Vision labs! UMD researchers will showcase projects like robotic arms, underwater computer vision, flapping robots, beamsplitter cameras, and more. The tour will take place across Iribe, AV Williams, and the Neutral Buoyancy Research Facility. It's a fantastic opportunity to explore cutting-edge research on campus! Meet us on the Iribe Ground Floor.",
            imageUrl: "/assets/meetings/labtour.jpg",
            githubLink: "",
            youtubeLink: "",
            location: "Iribe Ground Floor",
            timestamp: new Date("2024-10-17T18:00:00").getTime(),
            category: "Workshop",
            difficulty: "Beginner",
            semester: "Fall 2024",
        },
        {
            title: "Wikipedia Game: Webscraping Workshop! (attendance ~ 20+)",
            date: "Tuesday, Oct 1",
            description:
                "We held a workshop where we walked participants through automating the Wikipedia Game. The Wikipedia game was a simple competition to navigate from one Wikipedia article to another, using only links within Wikipedia articles. We used Python with Selenium and BeautifulSoup to explore the basics of different search algorithms and optimizations. At the end of the meeting, participants competed to find the shortest path between two articles, with prizes awarded for efficiency and the least clicks!",
            imageUrl: "/assets/meetings/webscraping.jpg",
            githubLink: "https://github.com/The-ACM-UMD/Webscraper-Workshop",
            youtubeLink: "",
            location: "Computer Science Instructional Center (CSI) 1121",
            timestamp: new Date("2024-10-01T18:00:00").getTime(),
            category: "Workshop",
            difficulty: "Medium",
            semester: "Fall 2024",
        },
        {
            title: "Building a Basic ChatGPT Clone (attendance ~ 50+)",
            date: "Tuesday, Sept 17th",
            description:
                "The workshop on building a basic ChatGPT clone was held from 6 to 7 PM in Iribe Room 4105, led by Co-President Ishan Kar. Members explored the fundamentals of artificial intelligence and natural language processing, learning how to create interactive chatbots using pre-trained language models. The session encouraged hands-on participation, allowing attendees to code and experiment with their own prototypes. Everyone left with valuable skills and a working chatbot, making it an engaging and rewarding experience!",
            imageUrl: "/assets/meetings/meeting1.jpg",
            githubLink: "https://github.com/acm-umd/ChatBot/tree/main",
            youtubeLink: "",
            location: "Iribe Room 4105",
            timestamp: new Date("2024-09-17T18:00:00").getTime(),
            category: "Workshop",
            difficulty: "Beginner",
            semester: "Fall 2024",
        },
    ];

    let eggRevealed = false;

    function handleEasterEggReveal() {
        eggRevealed = true;
    }

    // Sort workshops by date (most recent first)
    $: sortedWorkshops = [...workshops].sort(
        (a, b) => b.timestamp - a.timestamp,
    );

    // Filter workshops
    let showUpcoming = false;
    let selectedCategory = "all";
    let selectedDifficulty = "all";
    let selectedSemester = "all";

    $: filteredWorkshops = sortedWorkshops.filter((workshop) => {
        const now = new Date().getTime();
        const matchesTime = showUpcoming
            ? workshop.timestamp > now
            : workshop.timestamp <= now;
        const matchesCategory =
            selectedCategory === "all" ||
            workshop.category === selectedCategory;
        const matchesDifficulty =
            selectedDifficulty === "all" ||
            workshop.difficulty === selectedDifficulty;
        const matchesSemester =
            selectedSemester === "all" ||
            workshop.semester === selectedSemester;

        return (
            matchesTime &&
            matchesCategory &&
            matchesDifficulty &&
            matchesSemester
        );
    });

    $: uniqueCategories = [...new Set(workshops.map((w) => w.category))];
    $: uniqueDifficulties = [...new Set(workshops.map((w) => w.difficulty))];
    $: uniqueSemesters = [...new Set(workshops.map((w) => w.semester))].sort(
        (a, b) => {
            const [seasonA, yearA] = a.split(" ");
            const [seasonB, yearB] = b.split(" ");
            if (yearA !== yearB) return yearB - yearA;
            return seasonB === "Spring" ? 1 : -1;
        },
    );

    function formatDate(timestamp) {
        const date = new Date(timestamp);
        const options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        };
        return date.toLocaleDateString("en-US", options);
    }
</script>

<div class="workshops-page">
    <div bind:this={scrollTarget}></div>

    <div class="page-header">
        <h1 class="page-title">Workshops & Events</h1>
        <li>
            {#if !eggRevealed}
                <button
                    class="easter-egg-button"
                    on:click={handleEasterEggReveal}
                >
                    &#58;-&#41;
                </button>
            {:else}
                <span class="easter-egg-reveal">
                    🥚 Lucky Easter egg! There must be more - JZ!
                </span>
            {/if}
        </li>

        <p class="page-subtitle">
            Explore our upcoming and past workshops, tech talks, and events.
            Filter by semester, category, and difficulty level.
        </p>
    </div>

    <div class="filters-container">
        <div class="filter-group">
            <span class="filter-label">Time:</span>
            <button
                class="filter-button {showUpcoming ? 'active' : ''}"
                on:click={() => (showUpcoming = true)}
            >
                Upcoming Events
            </button>
            <button
                class="filter-button {!showUpcoming ? 'active' : ''}"
                on:click={() => (showUpcoming = false)}
            >
                Past Events
            </button>
        </div>

        <div class="filter-group">
            <span class="filter-label">Semester:</span>
            <select bind:value={selectedSemester} class="filter-select">
                <option value="all">All Semesters</option>
                {#each uniqueSemesters as semester}
                    <option value={semester}>{semester}</option>
                {/each}
            </select>
        </div>

        <div class="filter-group">
            <span class="filter-label">Category:</span>
            <select bind:value={selectedCategory} class="filter-select">
                <option value="all">All Categories</option>
                {#each uniqueCategories as category}
                    <option value={category}>{category}</option>
                {/each}
            </select>
        </div>

        <div class="filter-group">
            <span class="filter-label">Difficulty:</span>
            <select bind:value={selectedDifficulty} class="filter-select">
                <option value="all">All Levels</option>
                {#each uniqueDifficulties as difficulty}
                    <option value={difficulty}>{difficulty}</option>
                {/each}
            </select>
        </div>
    </div>

    {#if filteredWorkshops.length === 0}
        <div class="no-workshops">
            <h3>No workshops found matching your criteria</h3>
            <p>Try adjusting your filters or check back later for new events</p>
        </div>
    {:else}
        <div class="workshops-grid">
            {#each filteredWorkshops as workshop}
                <Workshop
                    title={workshop.title}
                    date={formatDate(workshop.timestamp)}
                    description={workshop.description}
                    imageUrl={workshop.imageUrl}
                    githubLink={workshop.githubLink}
                    youtubeLink={workshop.youtubeLink}
                    location={workshop.location}
                    zoomLink={workshop.zoomLink}
                    rsvpLink={workshop.rsvpLink}
                    category={workshop.category}
                    difficulty={workshop.difficulty}
                    semester={workshop.semester}
                />
            {/each}
        </div>
    {/if}
</div>

<style>
    .workshops-page {
        min-height: 100vh;
        background: linear-gradient(135deg, #1a1a1a, #2a2a2a);
        padding: 2rem;
        color: white;
    }

    .page-header {
        text-align: center;
        margin-bottom: 3rem;
        animation: fadeIn 1s ease;
    }

    .page-title {
        font-size: 3rem;
        font-weight: bold;
        margin-bottom: 1rem;
        background: linear-gradient(45deg, #ff4433, #ffd520);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .page-subtitle {
        font-size: 1.2rem;
        color: #888;
        max-width: 600px;
        margin: 0 auto;
    }

    .filters-container {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 15px;
        padding: 1.5rem;
        margin-bottom: 2rem;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        animation: slideUp 0.5s ease;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 1rem;
    }

    .filter-group {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    .filter-label {
        color: #ff4433;
        font-weight: 500;
        font-size: 0.9rem;
    }

    .filter-button {
        padding: 0.5rem 1rem;
        border: none;
        border-radius: 8px;
        background: rgba(255, 68, 51, 0.2);
        color: white;
        cursor: pointer;
        transition: all 0.3s ease;
        font-weight: 500;
        font-size: 0.9rem;
    }

    .link-button svg {
        width: 20px;
        height: 20px;
    }

    .date-icon svg,
    .location-icon svg {
        width: 20px;
        height: 20px;
    }

    .filter-select {
        padding: 0.5rem 1rem;
        border: none;
        border-radius: 8px;
        background: #1a1a1a;
        color: white;
        cursor: pointer;
        width: 100%;
        transition: all 0.3s ease;
        font-size: 0.9rem;
        position: relative;
    }

    .filter-select option {
        background: #1a1a1a;
        color: white;
        padding: 0.5rem;
        max-width: 100%;
        white-space: normal;
        word-wrap: break-word;
    }

    .workshops-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
        gap: 2rem;
        animation: fadeIn 1s ease;
    }

    .no-workshops {
        text-align: center;
        padding: 3rem;
        background: rgba(255, 68, 51, 0.1);
        border-radius: 15px;
        color: #ff4433;
        animation: fadeIn 1s ease;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @keyframes slideUp {
        from {
            transform: translateY(20px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    .easter-egg-button {
        padding: 0.3rem 0.6rem;
        border: none;
        border-radius: 6px;
        background-color: transparent;
        color: rgba(255, 255, 255, 0.3);
        font-size: 0.8rem;
        font-weight: normal;
        cursor: pointer;
        transition: all 0.2s ease;
        box-shadow: none;
        opacity: 0.3;
    }

    .easter-egg-button:hover {
        color: #ffd520;
        opacity: 0.7;
        transform: scale(1.05);
        background-color: rgba(255, 255, 255, 0.05);
    }

    .easter-egg-reveal {
        font-size: 0.9rem;
        color: #fff;
        background: rgba(255, 255, 255, 0.15);
        padding: 0.5rem;
        border-radius: 6px;
        display: inline-block;
        animation: popIn 0.4s ease;
    }

    @keyframes popIn {
        from {
            transform: scale(0.8);
            opacity: 0;
        }
        to {
            transform: scale(1);
            opacity: 1;
        }
    }

    @media (max-width: 768px) {
        .workshops-page {
            padding: 1rem;
        }

        .page-title {
            font-size: 2rem;
        }

        .page-subtitle {
            font-size: 1rem;
            padding: 0 1rem;
        }

        .filters-container {
            grid-template-columns: 1fr;
            padding: 1rem;
            gap: 0.75rem;
        }

        .filter-group {
            gap: 0.25rem;
        }

        .filter-label {
            font-size: 0.85rem;
        }

        .filter-button {
            padding: 0.4rem 0.8rem;
            font-size: 0.85rem;
        }

        .link-button svg {
            width: 16px;
            height: 16px;
        }

        .date-icon svg,
        .location-icon svg {
            width: 16px;
            height: 16px;
        }

        .filter-select {
            max-width: calc(100vw - 3rem);
        }

        .filter-select option {
            max-width: calc(100vw - 3rem);
        }

        .workshops-grid {
            grid-template-columns: 1fr;
            gap: 1.5rem;
            padding: 0 0.5rem;
        }
    }

    @media (max-width: 480px) {
        .workshops-page {
            padding: 0.75rem;
        }

        .page-title {
            font-size: 1.75rem;
        }

        .page-subtitle {
            font-size: 0.9rem;
            padding: 0 0.5rem;
        }

        .filters-container {
            padding: 0.75rem;
            gap: 0.5rem;
        }

        .filter-group {
            gap: 0.2rem;
        }

        .filter-label {
            font-size: 0.8rem;
        }

        .filter-button {
            padding: 0.35rem 0.7rem;
            font-size: 0.8rem;
        }

        .link-button svg {
            width: 14px;
            height: 14px;
        }

        .date-icon svg,
        .location-icon svg {
            width: 14px;
            height: 14px;
        }

        .filter-select {
            max-width: calc(100vw - 2rem);
        }

        .filter-select option {
            max-width: calc(100vw - 2rem);
            font-size: 0.8rem;
        }

        .workshops-grid {
            gap: 1.25rem;
            padding: 0 0.25rem;
        }

        .no-workshops {
            padding: 2rem 1rem;
            font-size: 0.9rem;
        }
    }
</style>
